import React from 'react';
import { Breadcrumb } from 'antd';
import { Link, useLocation } from 'react-router-dom';

const DynamicBreadcrumb = () => {
    const location = useLocation();
    const pathSnippets = location.pathname.split('/').filter((i) => i);

    const breadcrumbNameMap = {
        '/': 'Home',
        '/products': 'Products',
        '/categories': 'Categories',
        '/blog': 'Blog',
    };

    const extraBreadcrumbItems = pathSnippets.map((_, index) => {
        const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
        const isLast = index === pathSnippets.length - 1;
        const title = breadcrumbNameMap[url] || pathSnippets[index];

        return {
            key: url,
            title: isLast ? (
                <span>{title}</span>
            ) : (
                <Link to={url}>{title}</Link>
            ),
        };
    });

    const breadcrumbItems = [
        {
            key: 'home',
            title: <Link to="/">Home</Link>,
        },
    ].concat(extraBreadcrumbItems);

    const itemRender = (item, params, items, paths) => {
        const last = items.indexOf(item) === items.length - 1;
        return last ? (
            <span>{item.title}</span>
        ) : (
            item.title
        );
    };

    return (
        <div className="container">
            <div className="py-3">
                <Breadcrumb
                    items={breadcrumbItems}
                    itemRender={itemRender}
                    separator=">"
                />
            </div>
        </div>
    );
};

export default DynamicBreadcrumb;